import "./SinglePostTemplate.module.css"
import CorporateHeader from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import GlobalFooter from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <CorporateHeader />
      <SinglePostTemplateSection />
      <GlobalFooter />
    </div>
  )
}
